import React from "react";

const House = () => {
    return(
        <div className="w-full h-screen relative">
           <img className="w-full h-full object-cover" src="https://images.unsplash.com/photo-1585412727339-54e4bae3bbf9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80" alt=""/>
           <div className="absolute w-full h-full top-0 left-0 bg-gray-900/50"></div>
           <div className="absolute top-0 w-full h-full flex flex-col justify-center text-center text-white p-4">
            <h1 className="text-4xl">Motel for <span className="font-Dancing italic text-6xl text-orange-400">memorable</span> moments in emotions</h1>
           </div>
        </div>
    )
}

export default House;  